export class ListBackupJobsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "jobs",
            "baseName": "jobs",
            "type": "Array<BackupJob>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListBackupJobsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
